import { Box, Typography } from '@wishket/design-system';

export const PersonalizedButtonTooltip = () => {
  return (
    <Box className="absolute bottom-[63px] left-1/2 -translate-x-1/2 transform desktop:left-[41%]">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="10"
        height="5"
        viewBox="0 0 10 5"
        fill="none"
        className="absolute -bottom-[5px] left-1/2 -translate-x-1/2 transform desktop:left-[57%]"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M5 5L-6.07001e-07 8.74228e-07L10 0L5 5Z"
          fill="#6B16EE"
        />
      </svg>
      <Box className="flex h-7 w-[206px] items-center rounded-full bg-primary-500 px-3 py-1">
        <Typography variant="body3" className="text-white">
          다른 직무의 관심사가 궁금하다면?
        </Typography>
      </Box>
    </Box>
  );
};
